import React from 'react';
import { DeleteFilled } from '@ant-design/icons';
import {
    Button,
    message,
    Popconfirm,
} from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../config/axios';

export default function DeletePopupButton({ data }) {

    const [messageApi, contextHolder] = message.useMessage();
    const queryClient = useQueryClient();
    const { mutate } = useMutation({
        mutationFn: ({ _id }) => {
            axios
                .delete(`/api/user/${_id}`)
                .then(() =>  queryClient.invalidateQueries(['/api/user/']))
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'ไม่สามารถลบข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                    });
                })
        }
    });

    const confirm = (e) => mutate(data);

    return (
        <div>
            {contextHolder}
            <Popconfirm
                title="ลบข้อมูลรายการนี้"
                description="ต้องการจะลบข้อมูลรายการนี้ ใช่ หรือ ไม่?"
                onConfirm={confirm}
                okText="ใช่"
                cancelText="ไม่ใช่"
            >
                <Button danger icon={<DeleteFilled />} type='text' />
            </Popconfirm>
        </div>
    )
}
